import styles from './footer.module.css'
import {Link} from "react-router-dom";
import logo from '../../../images/Logo.png'

const Footer = () => {
  return (
	  <>
		  <div className={styles.container}>
			  <div className={styles.subscribe}>
				  <img src={logo} alt=""/>
				  <input type="email" placeholder='Never Miss any offers'/>
			  </div>
			  <div className={styles.links}>
				  <ul>
					  <li><Link to='/'>Home</Link></li>
					  <li><Link to='/menu'>Menu</Link></li>
					  <li><Link to='/about'>About Us</Link></li>
					  <li><Link to='/contact'>Contact Us</Link></li>
				  </ul>
			  </div>
		  </div>
	  </>
  )
}

export default Footer;